module.exports = __webpack_public_path__ + "assets/img/banner@2x.1fbda55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pageImgs/banner@2x.png
// module id = 284
// module chunks = 6